module.exports = __webpack_public_path__ + "static/media/21ECLAC33.d9b8be82.jpg";